import React from 'react';
import { NewsArticle } from '../../services/newsService';
import './NewsCard.css';

interface NewsCardProps {
  article: NewsArticle;
  dateFormatter: (date: string) => string;
}

const NewsCard: React.FC<NewsCardProps> = ({ article, dateFormatter }) => {
  // Função para gerar cor baseada no nome da fonte
  const getSourceColor = (source: string): string => {
    const colors = [
      'badge-primary',
      'badge-success', 
      'badge-info',
      'badge-warning',
      'badge-danger',
      'badge-secondary',
      'badge-dark',
    ];
    
    // Gera um hash simples baseado no nome
    let hash = 0;
    for (let i = 0; i < source.length; i++) {
      hash = source.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    return colors[Math.abs(hash) % colors.length];
  };

  return (
    <div className="card news-card h-100">
      {article.image && (
        <img 
          src={article.image} 
          alt={article.title}
          className="card-img-top"
          style={{ height: '200px', objectFit: 'cover' }}
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
          }}
        />
      )}
      <div className="card-body d-flex flex-column">
        <h5 className="card-title">
          <a 
            href={article.url} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-dark text-decoration-none"
          >
            {article.title}
          </a>
        </h5>
        <p className="card-text text-muted flex-grow-1">
          {article.description}
        </p>
        <div className="d-flex justify-content-between align-items-center mt-2">
          {article.sourceUrl ? (
            <a 
              href={article.sourceUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              className={`badge ${getSourceColor(article.source)} text-decoration-none`}
              title={`Ver mais notícias de ${article.source}`}
            >
              {article.source}
            </a>
          ) : (
            <span className={`badge ${getSourceColor(article.source)}`}>
              {article.source}
            </span>
          )}
          <small className="text-muted">
            <i className="far fa-clock mr-1"></i>
            {dateFormatter(article.publishedAt)}
          </small>
        </div>
      </div>
    </div>
  );
};

export default NewsCard;
